import React from 'react';
import logo from '../assets/Houzzdat_logo.jpg';
import { Link } from 'react-router-dom';

const NotFound = () => (
  <div className="flex flex-col items-center justify-center min-h-[60vh] py-12 px-4 text-center">
    <img src={logo} alt="Houzzdat Logo" className="h-16 w-auto mb-6" />
    <h1 className="text-4xl font-bold text-primary mb-2">404</h1>
    <h2 className="text-xl font-semibold text-accent mb-4">Page Not Found</h2>
    <p className="text-primary mb-6">Sorry, the page you are looking for does not exist or has been moved.</p>
    <Link to="/" className="px-6 py-2 bg-accent text-white rounded-xl shadow-soft font-semibold hover:bg-primary transition">Go to Home</Link>
  </div>
);

export default NotFound; 